import '../sass/app.scss'

console.log('JS: Header scripts loaded.');